export default __webpack_public_path__ + "981e5fe3827b6d908f9cc5be9c924dc5.png";